module.exports = __webpack_public_path__ + "static/media/DJ.51ebef33.png";